export function getZoomProportion(zoomLevel: number) {
    return Math.pow(2, zoomLevel - 1);
}